import styled from 'styled-components';
import { HideScrollbar } from '../../global/commonStyle';

export const OuterDiv = styled.div`
  height: 100dvh;
  overflow: hidden;
  position: relative;
  /* icon button back ground color on hover */
  .icon-button {
    &:hover {
      background-color: var(--background-muted);
    }
  }
`;

export const MainSection = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 47px);
  ${HideScrollbar}
`;

export const WorkloadSection = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
`;
